import qs from 'qs'

const fields = [
  'title',
  'slug',
  'locale',
  'richText'
]

export const queryPageEntryBySlug = (options: QueryBySlugOptions) => {
  const query = qs.stringify(
    {
      publicationState: options.publicationState || 'live',
      locale: options?.locale || 'nl-NL',
      filters: {
        slug: {
          $eq: options.slug
        }
      },
      fields: fields,
      populate: {
        ...queryFragmentSeo,
        ...queryFragmentBlocks,
        localizations: {
          fields: fields
        },
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `page-entries?${query}`
}
